import { useCitationLink } from "../hooks/useRenderCitationLink";

export function CitationLink({ citation, ticker, reportYear }) {
  const links = useCitationLink(citation, ticker, reportYear);
  if (!links || !Array.isArray(links) || !links.length) return null;
  return links.map((item, index) => <span key={index}>{item}</span>);
}
